module.exports = __webpack_public_path__ + "img/santoantoniojardim.fb89034c.png";